// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Icon from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';

const UnlockIconGlyph = (props: ComponentProps<'svg'>) => (
	<svg {...props} viewBox="0 0 24 24" focusable="false" role="presentation">
		<g fill="currentColor" fillRule="evenodd">
			<path
				d="M12,4 C14.209139,4 16,5.79182182 16,8.00236948 C15.9507283,8.55323146 15.6232086,8.82866245 15.017441,8.82866245 C14.4116734,8.82866245 14.0725264,8.55323146 14,8.00236948 C14,6.89616855 13.1043465,6 12,6 C10.8982909,6 10,6.89812584 10,8.00236948 L10,10 L15.9914698,10 C17.1007504,10 18,10.8874333 18,11.999615 L18,18.000385 C18,19.1047419 17.0980496,20 15.9914698,20 L8.0085302,20 C6.8992496,20 6,19.1125667 6,18.000385 L6,11.999615 C6,10.8979354 6.89758257,10.0043419 8.00048596,10.0000158 L8,8.00236948 C8,5.79192185 9.79535615,4 12,4 Z M12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 C13.1045695,17 14,16.1045695 14,15 C14,13.8954305 13.1045695,13 12,13 Z"
				id="path-1"
			/>
		</g>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			{}
			<mask id="mask-2" fill="white" />
			{}
			<use id="Mask" fill="#42526E" />
			{}
			<g id="Neutral-/-N500-AAA" mask="url(#mask-2)" fill="#7A869A">
				<polygon id="N500" points="0 24 24 24 24 0 0 0" />
			</g>
		</g>
	</svg>
);

const UnlockIcon = () => (
	<Icon
		primaryColor={token('color.icon.subtle', '#7A869A')}
		glyph={UnlockIconGlyph}
		label=""
		size="medium"
	/>
);

export default UnlockIcon;
